export const jhcassoAPIUri = {
  requestOtp: "v1/auth/o/sendotp",
  verifyOtp: "v1/auth/o/verifyotp",
  resendotp: "v1/auth/o/resendotp/",
  refreshToken: "v1/auth/o/refreshtoken",
  pmsTaskUri: "v1/pmstickets/task/",
  clients: "v1/clients/",
  dashboard: "v1/dashboard",
  employee: "v1/employee",
  gallery: "v1/gallery",
  notification: "v1/notification/salon",
  reviews: "v1/review",
  employeeId: "v1/employee/",
  timeslots: "v1/salon/timeslot",
  services: "v1/service/services",
  manageservice: "v1/service",
  profilenumber: "v1/verify/mobile/",
  profileotp: "v1/verify/mobile/",
  serviceupdate: "v1/service/",
  deleteService: "v1/service/",
  categories: "v1/data/categories",
  userprofile: "v1/users/profile",
  pushnotification: "v1/notification/status/",
  appsetting: "v1/data/app/settings",
  updateprofile: "v1/users",
  history: "v1/service/history",
  deleteGallery: "v1/gallery/",
  salonProfile: "v1/salon/profile",
  addSalon: "v1/salon",
  logout: "v1/auth/o/logout/",
  verifyEmail: "v1/verify/email/",
  salon: "v1/salon",
  clientappointments: "v1/clients/appointments/",
  updatestatus: "v1/booking/updatestatus",
  clientaddress: "v1/clients/address",
  selectEmp : "v1/employee/selectemp",
  validateTimeslots: "v1/timeslot/validate/",
  appointment: "v1/appointment/detail/",
  EmailTicket: "v1/pmstickets",
  deleteAccount: "v1/auth/o/deactivateaccount/",
  ticketRequest: "v1/support/tickets/types",
  submitRequest: "v1/support/tickets",
  ticketsHistory: "v1/support/tickets/history",
  supportCategory: "v1/support/category",
  historyCategory: "v1/support/category/history",

};
